import { useState } from 'react';
import { X } from 'lucide-react';
import { submitCallbackRequest } from '../api';
import './CallbackModal.css';

export default function CallbackModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      await submitCallbackRequest(form);
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
      setTimeout(() => {
        onClose();
        setStatus('idle');
      }, 2000);
    } catch {
      setStatus('error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <X size={22} />
        </button>

        <h3 className="modal-title">Schedule A Callback</h3>
        <p className="modal-desc">
          Reach out to us in the form below with any questions you may have.
        </p>

        {status === 'success' ? (
          <div className="form-success">
            <p>Thank you! We'll get back to you shortly.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label htmlFor="cb-name">Name *</label>
              <input
                id="cb-name"
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="cb-email">Email *</label>
              <input
                id="cb-email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
              />
            </div>
            <div className="form-group">
              <label htmlFor="cb-message">Comment or Message</label>
              <textarea
                id="cb-message"
                name="message"
                value={form.message}
                onChange={handleChange}
                rows={4}
                placeholder="How can we help?"
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary modal-submit"
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'Sending...' : 'Request Callback'}
            </button>
            {status === 'error' && (
              <p className="form-error">Something went wrong. Please try again.</p>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
